module.exports = flarum.core.compat['components/SignUpModal'];